import React from "react";
import { useLocalization } from "../localization";
import { usePrivacyConsent } from "./PrivacyConsentProvider";

type PrivacyChoicesButtonProps = {
  className?: string;
  label?: string;
};

const PrivacyChoicesButton = ({
  className = "",
  label = "Your Privacy Choices",
}: PrivacyChoicesButtonProps) => {
  const { t } = useLocalization();
  const { openPreferences, gpcEnabled } = usePrivacyConsent();

  return (
    <button
      className={className}
      type="button"
      onClick={openPreferences}
      aria-label={
        gpcEnabled
          ? t("Your Privacy Choices — Global Privacy Control honored")
          : t(label)
      }
    >
      {t(label)}
      {gpcEnabled ? (
        <span className="privacy-signal-indicator" aria-hidden="true">
          ✓
        </span>
      ) : null}
    </button>
  );
};

export default PrivacyChoicesButton;

